function LocationIcon({ ...rest }) {
  return (
    <svg
      width='16'
      height='19'
      viewBox='0 0 16 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M14.9091 7.95455C14.9091 13.3636 7.95455 18 7.95455 18C7.95455 18 1 13.3636 1 7.95455C1 6.11009 1.73271 4.34117 3.03694 3.03694C4.34117 1.73271 6.11009 1 7.95455 1C9.79901 1 11.5679 1.73271 12.8722 3.03694C14.1764 4.34117 14.9091 6.11009 14.9091 7.95455Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.9549 10.2731C9.2352 10.2731 10.2731 9.2352 10.2731 7.9549C10.2731 6.6746 9.2352 5.63672 7.9549 5.63672C6.6746 5.63672 5.63672 6.6746 5.63672 7.9549C5.63672 9.2352 6.6746 10.2731 7.9549 10.2731Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default LocationIcon;
